import { useSelector } from 'react-redux';
import { getAllowedUserPermissions } from '../../helpers/common';
import { isAdminRole, CHILDREN_TAB_LOCATION_CAPACITY } from '../../consts/management/users/users';

export default function useLocationCapacityAccess() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (isAdminRole(currentUser?.role)) return true;
  const { allowedChildIds } = getAllowedUserPermissions({
    permissions: currentUser?.permissions || [],
  });
  return allowedChildIds.has(CHILDREN_TAB_LOCATION_CAPACITY);
}
